import { createContext, useContext, useEffect, useMemo } from "react";
import { defaultTheme, getActiveTheme } from "./themeSelection";

const ThemeContext = createContext(defaultTheme);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    console.warn(
      "useTheme must be used within ThemeProvider, falling back to default theme",
    );
    return defaultTheme;
  }
  return context;
};

const generateCSSVariables = (theme) => {
  return {
    "--clr-primary": theme.primary,
  };
};
const applyCSSVariables = (cssVars) => {
  Object.entries(cssVars).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
};

export const ThemeProvider = ({ children }) => {
  const theme = useMemo(getActiveTheme, []);

  useEffect(() => {
    const cssVars = generateCSSVariables(theme);
    applyCSSVariables(cssVars);

    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon && theme.favicon) {
      favicon.href = theme.favicon;
    }

    if (theme.appName) {
      document.title = theme.appName;
    }

    if (theme.fontFamily) {
      document.body.style.fontFamily = theme.fontFamily;
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
};
